<!-- APP-角色管理 -->
<template>
  <div class="md-layout">
    <!-- 主体 -->
    <div v-if="select_user_id === ''" class="md-layout-item md-size-100">
      <!-- 卡片 -->
      <md-card>
        <md-card-content>
          <!-- 卡片-查询表单 -->
          <div class="md-layout card-form" style="max-width: 800px;">
            <div class="md-layout-item md-size-20 left-layout-item md-xsmall-size-50">
              <md-field>
                <label>APP</label>
                <md-select v-model="searchForm.app">
                  <md-option :value="'__ALL__'">{{$I18n("all")}}</md-option>
                  <md-option v-for="item in appList" :key="item.id" :value="item.id">{{item.name}}</md-option>
                </md-select>
              </md-field>
            </div>
            <div class="md-layout-item md-size-20 left-layout-item md-xsmall-size-50">
              <md-field>
                <label>{{$I18n("user_id")}}</label>
                <md-input v-model="searchForm.user_id"/>
              </md-field>
            </div>
            <div class="md-layout-item md-size-20">
              <md-button class= "left-icon md-info" @click="form_changeSearchData" v-if="!$root.state.mobile">
                <md-icon>search</md-icon>
                {{$I18n("search")}}
              </md-button>
            </div>
          </div>
        </md-card-content>
      </md-card>
      <md-card>
        <md-card-content>
          <div class="md-layout-item right-layout-item">
            <md-button class= "left-icon md-info" @click="openUser" v-if="!$root.state.mobile">
              {{$I18n("search_data_center")}}
            </md-button>
            <md-button class= "left-icon md-info" @click="openDev" v-if="!$root.state.mobile">
              {{$I18n("search_dev")}}
            </md-button>
            <md-button class= "left-icon md-info" @click="openUpload" v-if="!$root.state.mobile">
              {{$I18n("tag_import")}}
            </md-button>
            <md-button class= "left-icon md-info" @click="openUpTable" v-if="!$root.state.mobile">
              {{$I18n("tag_record")}}
            </md-button>
          </div>
          <!-- <div> -->
          <md-table v-model="tableData">
            <!-- ID  账号 邮箱  手机 注册APP  登录时间 登录IP 注册时间 -->
            <md-table-row slot="md-table-row" slot-scope="{ item }" >
              <md-table-cell :md-label="'ID'">{{ item.id }}</md-table-cell>
              <md-table-cell :md-label="$I18n('user_id')">{{ item.user_id }}</md-table-cell>
              <md-table-cell :md-label="$I18n('email_or_phone')">{{ item.mail ?item.mail.slice(0,32)+"..." :(item.phone ?item.phone :"")}}</md-table-cell>
              <md-table-cell :md-label="'APP'">{{ item.app_name }}</md-table-cell>
              <md-table-cell :md-label="$I18n('app_id')">{{ item.app_id }}</md-table-cell>
              <md-table-cell :md-label="$I18n('login_date')">{{ item.login_time }}</md-table-cell>
              <md-table-cell :md-label="$I18n('login_ip')">{{ item.ip }}</md-table-cell>
              <md-table-cell :md-label="$I18n('created_time')">{{ item.create_time }}</md-table-cell>
              <md-table-cell :md-label="$I18n('tag')">
                <div style="display: flex;flex-wrap: wrap;">
                  <div 
                    @click="() => setTags(item, tag)"
                    v-for='tag in ["vip", "white_list", "logs", "advertis"]' 
                    :key="tag"
                    class="tagbox"
                    :class="{'selected': item.tags_list.includes(tag)}"
                  >{{$I18n(tag)}}</div>
                </div>
              </md-table-cell>
              <md-table-cell :md-label="$I18n('operate')"  class="button-box">
                <table-button @click="() => setUserId(item)" icon="info" color="md-info" no-left/>
              </md-table-cell>
            </md-table-row>
            <md-table-empty-state slot="md-table-empty-state">
              {{$I18n("none_data")}}
            </md-table-empty-state>
          </md-table>
          <table-page :total="total" :pageSize="pageSize" v-model="currentPage"/>
        </md-card-content>
      </md-card> 
    </div>
    <!-- 详情 -->
    <div v-else class="md-layout-item md-size-100">
      <md-card>
        <!-- 卡片头 -->
        <md-card-header class=" md-card-header-icon md-card-header-blue">
          <h4 class="title">
            <span style="margin-left: 7px; line-height: 40px;">{{select_user_id}}</span>
            <md-button @click="resetUserId" class="md-primary md-sm md-info right-button md-just-icon md-round">
              <md-icon>reply</md-icon>
            </md-button>
          </h4>
        </md-card-header>
        <md-card-content class="md-layout">
          <div class="md-layout-item md-size-100 line"></div>
          <div class="menu scroll md-layout-item md-size-20 md-small-size-30 md-xsmall-size-100" :style="{'border-right':'1px solid rgba(180, 180, 180, 0.3)','margin-top':'20px'}">
            <div class="main-box">
              <template v-for="(firItem, firIndex) in menusList">
                <div v-if="firIndex > 0" :key="firIndex" class="line"></div>
                <div v-for="secItem in firItem" :key="secItem" @click="() => {active = secItem}" :class="{'selected': active == secItem }" class="menu-item-box">
                  {{secItem}}
                </div>
              </template>
            </div>
          </div>
          <div class="scroll md-layout-item md-size-80 md-small-size-70 md-xsmall-size-100" 
            :style="{'margin-top':'20px','max-height':'calc( 100vh - 192px - 64px - 51px );'}"
          >
            <!-- 设备管理 ../UserDev.vue -->
            <user-dev v-if='active === $I18n("device_manage")' :user="select_user_id" :sip="userinfo_database"/>
          </div>
        </md-card-content>
      </md-card>
    </div>

    <!-- 弹窗 -->
    <simple-modal ref="device" :title="modal_title" right large :submitBtn="false">
      <device :ip="userinfo_database" slot="body" />
    </simple-modal>

    <simple-modal ref="userDetail" :title="$I18n('search_data_center')" right large :submitBtn="false">
      <user-detail :userinfo_sys="userinfo_sys" :app_list="appList"  slot="body" />
    </simple-modal>

    <simple-modal ref="upload" :title="$I18n('tag_import')" right @submit="modal_submit">
      <div slot="body">
        <common-form-item >
          <file-input :error="modalXlsData.Error.link_id" @change="changeXLS">
            <md-input :style="{'width':'100%'}" v-model="modalXlsData.Form.link_id_file" readonly :placeholder="$I18n('click_select_file')"/>
          </file-input>
        </common-form-item>
      </div>
      <a href="/files/usertag.xlsx" :download='"usertag.xlsx"' slot="footer-btn">
        <md-button class="left-icon md-info">{{$I18n("frame")}}</md-button>
      </a>
    </simple-modal>
    <simple-modal ref="uptable" :title="$I18n('tag_record')" right large :submitBtn="false">
      <user-uptable slot="body" />
    </simple-modal>
  </div>
</template>
<script>
import FileInput from "@/components/Common/FileInput.vue"
import UserDev from "@/pages/Dashboard/App/UserDev.vue";
import Device from "@/pages/Dashboard/App/User/Dev.vue";
import UserDetail from "@/pages/Dashboard/App/User/UserDetail.vue";
// import UserUpload from "@/pages/Dashboard/App/User/UserUpload.vue";
import UserUptable from "@/pages/Dashboard/App/User/UserUptable.vue";
import {timestampToString, FormClass} from "@/common/tools.js";
export default {
  components: {
    FileInput,
    Device,
    UserDev,
    UserDetail,
    // UserUpload,
    UserUptable,
  },
  props: ["userinfo_sys", "userinfo_database"],
  data() {
    return {
      modalXlsData: new FormClass({
        link_id: "",
        link_id_file: "",
      }),
      modal_title: this.$I18n("equipment"),
      active: this.$I18n("device_manage"),
      menusList : [
        [
          this.$I18n("device_manage")
        ]
      ],
      select_user_id:"",
      appList : [],
      searchForm : {
        app : "__ALL__",
        user_id:"",
      },
      searchData : {
        app : "",
        user_id:"",
      },
      continent : {
        "AF" : this.$I18n("africa"),
        "EU" : this.$I18n("europe"),
        "AS" : this.$I18n("asia"),
        "OA" : this.$I18n("oceania"),
        "NA" : this.$I18n("north_america"),
        "SA" : this.$I18n("latin_america"),
        "AN" : this.$I18n("antarctica"),
      },
      // 表格相关
      icon  : "computer",
      title : this.$I18n("device_info"),
      tableInitData : [], // 表格数据

      // 分页相关
      pageSize : 10,
      currentPage : 1,
      total : 0,
    };
  },
  mounted : function() {
    this.api_getApp()
      .then(() => {
        this.searchData.master_id = this.searchForm.app === "__ALL__" ?"" :this.searchForm.app;
      })
      .then(this.api_getPageData)
  },
  watch: { 
    'userinfo_sys' : {
      handler(){
        this.api_getModalServerData();
      }
    },
    '$root.state':{
      handler(){
        return 
      },
      immediate: true,
      deep: true,
    },
    currentPage(){
      this.api_getPageData()
    },
  },
  computed: {
    // 表格数据
    tableData(){
      if (!this.tableInitData || this.tableInitData.length === 0){
        return [];
      } else {
        return [...this.tableInitData]
          .map(item => {
            const masterAppInfo = this.appList.filter(app => app.id === item.master_id)[0];
            let tagsList = [];
            if(item.tag){    
              if(item.tag.vip == 1){
                tagsList.push("vip")
              } 
              if(item.tag.white == 1) {
                tagsList.push("white_list")
              } 
              if(item.tag.log == 1) {
                tagsList.push("logs")
              } 
              if(item.tag.ad == 1) {
                tagsList.push("advertis")
              }
            }
            return {
              ...item,
              tags_list : tagsList,
              tags_string: tagsList.join(", "),
              app : masterAppInfo ?masterAppInfo.name :"",
              create_time: item.gmt_create ?timestampToString(item.gmt_create * 1000) :"",
              login_time : item.gmt_login ?timestampToString(item.gmt_login * 1000) :"",
            }
          })
      }
    },
  },
  methods: {
    modal_submit(){
      this.$api.setUserTagsXls({
        link_id  : this.modalXlsData.Form.link_id,
        link_type: 1,
        type     : 1,
      })
        .then(this.$Then(() => {
          this.$refs.upload.close();
        }))
        .catch(this.$Catch("get_error"))
    },
    changeXLS(value, name){
      this.modalXlsData.Form.link_id = value;
      this.modalXlsData.Form.link_id_file = name;
    },
    // 0->1 1->2 2->1转换
    switchNum(num){
      if(num == 1){
        return 2
      } else {
        return 1
      }
    },
    setTags(user, tag){
      let sendData = {
        user_id : user.user_id,
        user_nid: user.id,
        ...user.tag,
      }
      if(tag === "vip"){
        sendData.vip = this.switchNum(sendData.vip)
      } else if(tag === "white_list"){
        sendData.white = this.switchNum(sendData.white)
      } else if(tag === "logs"){
        sendData.log = this.switchNum(sendData.log)
      } else if(tag === "advertis"){
        sendData.ad = this.switchNum(sendData.ad)
      }
      this.$api.setUserTags(sendData)
        .then(() => {
          this.api_getPageData()
        })
        .catch(this.$Catch(this.$I18n("get_error")))
    },
    openUpload(){
      this.modalXlsData.Reset();
      this.$refs.upload.open();
    },
    openUpTable(){
      this.$refs.uptable.open();
    },
    openDev(){
      this.$refs.device.open();
    },
    openUser(){
      this.$refs.userDetail.open();
    },
    resetUserId(){
      this.select_user_id = "";
    },
    setUserId(item){
      this.select_user_id = item.user_id;
    },
    // API-APP 获取
    api_getApp(){ // API-获取APP列表
      return this.$api.queryAppBase({ // api: /user/app/query
        page_no   : 1,
        page_size : 9999,
      })
        .then(this.$Then(res => {
          this.appList = res.data;
        }))
        .catch(this.$Catch(this.$I18n("get_error"),() => {
          this.appList = [];
        }))
    },
    // API-表格数据
    api_getPageData(){
      this.$api.getAppUserList({
        ...this.searchData,
        sys      : this.userinfo_sys,
        comp_id  : this.UserInfo.role_id < 10000 ?0 :this.UserInfo.comp_id,
        page_size: this.pageSize,
        page_no  : this.currentPage,
      })
        .then(this.$Then(res => {
          this.tableInitData = res.data;
          this.total  = res.count
        }))
        .catch(this.$Catch(this.$I18n("get_error"),() => {
          this.tableInitData = [];
          this.total  = 0;
        }))
    },
    // 更改查询条件(并立刻查询)
    form_changeSearchData () {
      this.searchData = {
        master_id: this.searchForm.app === "__ALL__" ?"" :this.searchForm.app,
        sip : this.userinfo_database,
        uid : this.searchForm.uid,
        user_id: this.searchForm.user_id,
      };
      this.api_getPageData();
    },
  },
}
</script>
<style lang="scss" scoped>
  .tagbox{
    background: #dddddd;
    margin: 2px 4px;
    border-radius: 4px;
    padding: 2px 6px;
    font-size: 12px;
    cursor:pointer;
  }
  .tagbox.selected{
    background: #00bcd4 !important;
    color: #FFF;
  }
  .md-layout-item .version {
    transition: all 0s;
  }
  .line{
    content: "";
    height: 1px;
    width: calc(100% - 15px);
    background-color: rgba(180, 180, 180, 0.3);
  }
  .sec-side{
    font-size: 16px;
    font-weight: 300;
    height: 70px;
    width: 200px;
    box-sizing: border-box;
    padding: 15px 12px;
    line-height: 40px;
  }
  .sec .menu-item-box{
    height: 60px; 
    padding: 8px 12px;
    display: flex;
    margin-right: 8px;
  }
  .menu-item-box{
    font-size: 14px;
    height: 40px;
    margin: 6px 0;
    box-sizing: border-box;
    padding: 4px 12px;
    line-height: 32px;
    // width: calc( 100% - 15px );
    cursor: pointer;
    border-radius: 4px;
    transition: background .2s;
  }
  .menu-item-box.selected{
    background: #00bcd4;
    color: #ffffff;
  }
  .menu-item-box:hover{
    background: #f4f4f4;
  }
  .menu-item-box.selected:hover{
    background: #00bcd4;
  }
  .main-box{
    margin-top: 10px;
    margin-bottom: 10px;
    padding-left: 0;
    // box-shadow: 0px 0 10px #a9a9a9;
    // padding-left: 20px;
    margin-right: 10px;
    box-sizing:border-box;
  }
  .scroll{
    max-height: calc( 100vh - 192px - 64px - 51px );
    overflow-y: auto;
    overflow-x: hidden;
    // padding-right: 0;
    transition: all 0s !important;
  }
  .scroll::-webkit-scrollbar {
    /*滚动条整体样式*/
    width : 8px;  /*高宽分别对应横竖滚动条的尺寸*/
    height: 1px;
  }
  .scroll::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 8px;
    // box-shadow   : inset 0 0 5px rgba(0, 0, 0, 0.1);
    background : transparent;
  }
  .scroll::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    // box-shadow   : inset 0 0 5px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    background : transparent;
  }
  .scroll:hover::-webkit-scrollbar-thumb {
    background   : #00bcd4;
  }
  .scroll:hover::-webkit-scrollbar-track {
    background   : rgb(0 188 212 / 5%);
  }

    .content{
      display : contents;
    }

    .right_box{
        margin: 8px 16px;
        width: 70%;
        max-width: 400px;
        float: right;
        clear: both;
    }
    .left_box{
        margin: 8px 16px;
        width: 70%;
        max-width: 400px;
        float: left;
        clear: both;
    }
    .name {
        font-size: 16px;
        line-height: 24px;
    }
    .right_box .name {
        margin-right: 44px;
        text-align: right;
    }
    .left_box .name {
        margin-left: 44px;
        text-align: left;
    }
    .message {
        width: calc(100% - 44px);
        border: 2px solid #ccc;
        padding: 6px;
        color: #000000;
        border-radius: 8px;
        margin-top: 4px;
        line-height: 20px;
        font-size: 14px;
        word-wrap:break-word;
        text-align: left;
        float: left;
    }
    .face.left {
        float: left;
        margin-top: 4px;
    }

    .face.right {
        float: right;
        margin-top: 4px;
    }
    .left_box .message{
        margin-left: 8px;
    }
    .right_box .message{
        margin-right: 8px;
    }
    .time{
        clear: both;
        font-size: 12px; 
        color: #999;
    }
    .right_box .time{
        margin-right: 44px; 
        text-align: right;
    }
    .left_box .time{
        margin-left: 44px; 
        text-align: left;
    }
  .not-bind{
    font-weight:200 !important;
  }
  .md-card-only-title{
    margin: 0;
    box-shadow: none !important;
    text-align: left;
    position: relative;
    top: -12px;
    left: -20px;
  }
  .md-card-only-title .title{
    text-align:left !important;
  }
  .md-layout {
    overflow: hidden;
  }
  @media screen and (max-width: 600px){
    .scroll.menu{
      margin-top : 0 !important;
      border-right: 0 !important;
      max-height: none;
      padding: 0;
      overflow-y: auto;
      overflow-x: auto;
      border-bottom: 1px solid rgba(180, 180, 180, 0.3);
    }
    .scroll{
      max-height: none;
    }
    .line{
      display: none;
    }
    .main-box {
      margin: 0;
      display:flex;
    }
    .main-box .menu-item-box{
      width: auto;
      display: inline-block;
      white-space: nowrap;
    }
  }
  .canclick:hover, .canclick.selected {
    color : #26c6da;
    cursor: pointer;
  }
  .left-btn {
    text-align:left;
  }
  .md-date-form-item {
    height : 36px;
    border : none;
  }
  .left-table{
    margin-top: 16px;
  }
  .card-form {
    margin-top: 12px;
  }
  // 左侧表单对齐表格
  .left-layout-item{
    padding-rigth:8px;
    padding-left:8px;
  }
  // 表单右侧对齐表格
  .right-layout-item{
    text-align: right;
    padding:0;
  }

  // 表单里的单选框
  .radio-layout{
    margin-top: 6px;
  }
  // 弹窗
  .lg-modal .modal-container{
    width : 80%;
    max-width: unset;
  }
  // 表格的ID列
  .numbers {
    width: 160px;
  }
  // 表格的按钮列
  .button-box {
    width: 120px;
  }
  //左侧iocn
  .left-icon{
    margin-left: 16px;
  }
  // flaot 右的按钮
  .right-button {
    float:right;
  }

  .text-right .md-table-cell-container {
    display: flex;
    justify-content: flex-end;
  }
  .md-table .md-table-head:last-child {
    text-align: right;
  }

  .table-stats {
    display: flex;
    align-items: center;
    text-align: right;
    flex-flow: row wrap;

    .td-price .td-total {
      display: inline-flex;
      font-weight: 500;
      font-size: 1.0625rem;
      margin-right: 50px;
    }

    &.table-striped .td-price {
      border-bottom: 0;
    }

    .td-price {
      font-size: 26px;
      border-top: 1px solid #ddd;
      border-bottom: 1px solid #ddd;
    }

    .td-price,
    > div {
      flex: 0 0 100%;
      padding: 12px 8px;
    }
  }
</style>
